import { uuid } from 'utils';
import { ICycle, IOffsiteCampaign, IPercentageSplit, ISegment, ISegmentFilter } from '../entities/offsiteCampaign';

export function cloneCampaign(campaign: IOffsiteCampaign, name: string) {
  const rawClone = JSON.parse(JSON.stringify(campaign)) as IOffsiteCampaign;

  const updatedClone: IOffsiteCampaign = {
    ...rawClone,
    id: undefined,
    name: name,
    updatedAt: undefined,
    updatedById: undefined,
    createdById: undefined,
    createdAt: undefined,
    segments:
      rawClone.segments !== null && rawClone.segments !== undefined
        ? rawClone.segments.map(segment => cloneSegment(segment))
        : [],
  };

  return updatedClone;
}

export function cloneSegment(segment: ISegment): ISegment {
  return {
    ...segment,
    id: uuid(),
    segmentFilters: segment.segmentFilters?.map(segmentFilter => cloneSegmentFilter(segmentFilter)),
    percentageSplits: segment.percentageSplits?.map(split => clonePercentageSplit(split)),
  };
}

function cloneSegmentFilter(filter: ISegmentFilter) {
  return { ...filter, id: uuid() };
}
function clonePercentageSplit(percentageSplit: IPercentageSplit): IPercentageSplit {
  return { ...percentageSplit, id: uuid(), cycles: percentageSplit.cycles.map(cycle => cloneCycle(cycle)) };
}

function cloneCycle(cycle: ICycle) {
  return { ...cycle, id: uuid() };
}
